import {Ease, PIXI} from '@colonist/pixi'
import {CardView} from '../../../../shared/scripts/ui_canvas_engine/CardView'
import {SectionBgView} from '../../../../shared/scripts/ui_canvas_engine/SectionBgView'
import {UIGameManager} from '../../../../shared/scripts/ui_game/UIGameManager'
import {UIGameConstants} from '../../../../shared/scripts/ui_game/UIGameConstants'
import {CardEnum} from '@colonist/game-states'

interface UIGameUniqueCard {[key: string]: number}
export class UIMGamePlayerCardsExchangeView extends SectionBgView {
    private readonly uiGameManager: UIGameManager
    private readonly ease: Ease

    private readonly cards: CardView[] = []

    private readonly cardHeight: number
    private readonly cardWidth: number
    private readonly marginBetweenCards: number

    private readonly EASE_IN_ANIMATION_TIME: number = 200
    private readonly STAY_ANIMATION_TIME: number = 800

    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, uiGameManager: UIGameManager, incomingCards: CardEnum[], outgoingCards: CardEnum[], callback: () => void) {
        super(x, y, w, h, container)
        this.uiGameManager = uiGameManager
        this.ease = new Ease({useRef: false})
        this.cardHeight = h
        this.cardWidth = this.cardHeight / UIGameConstants.CARD_RATIO
        this.marginBetweenCards = this.uiGameManager.canvasController.margin / 2

        const uniqueCardsMap = this.createUniqueCardsMap(incomingCards, outgoingCards)
        this.populateCardViews(uniqueCardsMap, incomingCards, outgoingCards)

        setTimeout(() => {
            this.destroy()
            callback()
        }, 2 * this.EASE_IN_ANIMATION_TIME + this.STAY_ANIMATION_TIME)
    }

    private animate(card: CardView, finalY: number) {
        if(card.destroyed) return

        card.alpha = 0
        this.ease.add(card, {alpha: 1, y: 0}, {duration: this.EASE_IN_ANIMATION_TIME, ease: 'easeInSine'})
        this.ease.once('complete', () => {
            if(card.destroyed) return

            setTimeout(() => {
                this.ease.add(card, {alpha: 0, y: finalY}, {duration: this.EASE_IN_ANIMATION_TIME, ease: 'easeOutSine'})
            }, this.STAY_ANIMATION_TIME)
        })
    }

    // eslint-disable-next-line class-methods-use-this
    private createUniqueCardsMap(incomingCards: CardEnum[], outgoingCards: CardEnum[]): UIGameUniqueCard {
        const uniqueCards = {}
        incomingCards.forEach((card: CardEnum) => {
            uniqueCards[card] = (uniqueCards[card] ?? 0) + 1
        })
        outgoingCards.forEach((card: CardEnum) => {
            uniqueCards[card] = (uniqueCards[card] ?? 0) - 1
        })
        return uniqueCards
    }

    private populateCardViews(uniqueCards: UIGameUniqueCard, incomingCards: CardEnum[], outgoingCards: CardEnum[]) {
        const animationDistance = 20
        let cardX = this.xOffset(uniqueCards)
        const allCards = [...outgoingCards, ...incomingCards]
        for(const card of allCards) {
            const count = uniqueCards[card]
            if(count === 0) continue
            const yForAnimation = count > 0 ? -animationDistance : animationDistance
            const view = new CardView(this.uiGameManager, count, cardX, yForAnimation, this.cardWidth, this.cardHeight, card, this, false, false)
            const finalY = count > 0 ? animationDistance : -animationDistance
            this.animate(view, finalY)
            this.cards.push(view)
            cardX += this.cardWidth + this.marginBetweenCards
            uniqueCards[card] = 0
        }
    }

    private xOffset(uniqueCards: UIGameUniqueCard) {
        const totalCards = Object.keys(uniqueCards).length
        const totalWidth = (this.cardWidth * totalCards) + (this.marginBetweenCards * (totalCards - 1))
        return (this.width - totalWidth) / 2
    }
}
